import { useAuth } from '@/composables/useAuth'
import { useCentrifugo } from '@/composables/useCentrifugo'
import {
    STOP_LISTS_VIEW_PERMISSION,
    FOREMAN_VIEW_PERMISSION,
} from '@/constants/permissions'
import { notificationService } from '@/utils/notifications'

export function useStopListNotifications() {
    const { user, hasPermission } = useAuth()
    const { connect, subscribe } = useCentrifugo()

    /**
     * Обработчик входящих уведомлений по стоп-листам
     * @param {object} data - Данные, пришедшие от Centrifugo
     */
    const handlePublication = data => {
        // Работаем только с нужным типом событий и проверяем, что есть сообщение
        if (data.type !== 'stoplist_expiration' || !data.message) {
            return
        }

        notificationService.showWarning(data.message, undefined, undefined, {
            id: `stoplist-item-${data.menu_item_id}`,
            timeout: 10 * 1000,
        })
    }

    /**
     * Инициализирует подключение и подписки на каналы стоп-листов
     */
    const init = () => {
        if (!user) return

        const { divisions } = user.value
        const hasDivisions = divisions && divisions.length > 0
        const hasRequiredPermission =
            hasPermission(STOP_LISTS_VIEW_PERMISSION) ||
            hasPermission(FOREMAN_VIEW_PERMISSION)

        if (!hasDivisions || !hasRequiredPermission) {
            return
        }

        connect()

        divisions.forEach(division => {
            if (division.id) {
                const channel = `eds:stoplist:division_${division.id}`
                subscribe(channel, handlePublication)
            }
        })
    }

    return {
        initStopListNotifications: init,
    }
}
